"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const convertOversToBallsTotal_1 = __importDefault(require("../innings/convertOversToBallsTotal"));
const getStrikeRateBowler = (props) => {
    if (!props.ballsPerOver)
        props.ballsPerOver = 6;
    if (Number(props.overs) > 0 && props.wickets > 0) {
        const totalBalls = (0, convertOversToBallsTotal_1.default)({
            ballsPerOver: props.ballsPerOver,
            overs: props.overs
        });
        return Number((totalBalls / props.wickets).toFixed(2));
    }
    return null;
};
exports.default = getStrikeRateBowler;
//# sourceMappingURL=getStrikeRateBowler.js.map